import { List, Stack, Text, Title } from '@mantine/core';

export const ManagingAccounts = () => {
    return (
        <Stack gap="md">
            <Title order={3}>Managing Accounts</Title>

            <Text>The login application remembers your accounts on this device. You can manage multiple accounts and switch between them without re-entering your email address each time.</Text>

            <Title order={4} td="underline">Adding a New Account</Title>

            <List type="ordered" spacing="sm">
                <List.Item>Click "Use another account" on the account selection screen</List.Item>
                <List.Item>Enter your email address</List.Item>
                <List.Item>The system will look up your account and add it to your device</List.Item>
            </List>

            <Title order={4} td="underline">Switching Between Accounts</Title>

            <Text>If you have multiple accounts, they will all appear on the account selection screen. Click on the account you want to use to continue.</Text>

            <Title order={4} td="underline">Signing Out</Title>

            <List spacing="sm">
                <List.Item><strong>Sign Out</strong> — Signs you out of the selected account but keeps it saved on your device for next time</List.Item>
                <List.Item><strong>Sign Out and Forget</strong> — Signs you out and removes the account from this device. You will need to enter your email address again to use this account.</List.Item>
            </List>

            <Title order={4} td="underline">Hiding an Account</Title>

            <Text>You can hide an account from the selection screen without signing out. This is useful if you have accounts you rarely use but don't want to remove completely.</Text>
        </Stack>
    );
};
